<template lang="pug">
  li.item-container.sheet-tile
    .attribute.destination-name {{ sheet.destination_name }}
    .attribute.aspect {{ sheet.aspect }}
    .attribute.hawwwai-id {{ sheet.id.replace(/^ts_/, '') }}
    .attribute.thumbnail
      img(:src="`data:image/png;base64, ${(sheet.thumbnail && sheet.thumbnail.blob) || fallbackThumbnail}`")
    .attribute-container.sheet-info
      .attribute.justify-left.type {{ getBordereau(sheet) }}
      .attribute.justify-left.name {{ getName(sheet) }}
      .attribute-container.address
        .attribute.justify-left
          .attribute.city {{ sheet.location.address.city }},
          .attribute.zip {{ sheet.location.address.zip }}
        .attribute.justify-left.detail {{ sheet.location.address.value }}
</template>

<script>
import bordereauxInternes from '@/ressources/bordereaux-internes.js';

export default {
  name: 'SheetTile',
  props: {
    sheet: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fallbackThumbnail: '/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAsNDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ3/wQARCAB4ALQDABEAAREAAhEA/8QAUwABAAMBAAMAAAAAAAAAAAAAAAMEBQECBgcQAQACAQIBBgoIBwEAAAAAAAABAgMREgQhMTJCUmETIjRBUWJygqHwFBUjcYGRkqIzQ1NzssHC8f/aAAwDAAABAAIAAD8A+uOOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKmTi8OOdus3v2aRu5fR6ARfSsvPHCZtPn1QdrxuPXbkrfDb16zoC9ExMRMTExPNMaTGnpiQdAAAAAAAAAAAAAAAAABm5b34jJPD4Z20r/GyR8a1n4etbXqxYFvFgx4Y0pWO+3Wn59EeKCcHhelL1nfWtq+t88gMWmeMGW/gd9+GiY3eeK8vSp+PR7YNysxaItE6xMaxIOgAAAAAAAAAAAAAAAg4jJ4LDkv54rO32p5K/GQQYK+A4bfprbZOW3fO3dHL93ICh9YZuxj/AHAqR4XLk313Ta1t26NYiLa66zbmrEd/RrALuXPfPHg4vWMdY+2yxExSfjrt15Kx0stgXeFrivw81rTSlptW27ltbSelbvmOXTq9UHOCmYrkw25Zw3msezMzp8Yn8wXwAAAAAAAAAAAAAAAUeP8AJ7e1XX7t3/gJsnk9/wCzb8tgPWq1te0VrGsz86/dEctpnog1LWtxExw3DeLhrEb7+aYj0+rr717Ao5rRFpxUn7OlpiNOvaI0te0+eddYr1a16INjgPJ/fuDmDyvivc/MGgAAAAAAAAAAAAAAACLNj8LivTtVkFXh7xl4e2O07bUrbFfXniNJrFuXu/dEgzaY5vM4ME6x/Nzac8a9H2O7pXt0gXbcHk02Y8sUx9mN2tvWvyxumfR0a18WoIfq6/8AVr+kF/HWOFwTutrt3WmdNNder/qoI+CrbZfLbpZr7/d18X57OgL4AAAAAAAAAAAAAAAAMvi+GvO7Lh11tGmWkdeO6PPPajrf5BJwuXh4pGOk7L9at9ItNvx5Lf8APZBoAhyZsWKNb3rHdz2/SCjpk4y0Tas04as6xWelk757u/o16vjA1IjSNI5o00jzcnNAAAAAAAAAAAAAAAAAAAIMnD4cvTpHtR0gVvoGLt5o7t4JcfB4Mc67N0+m87gWwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf/2Q==',
    }
  },
  methods: {
    getName(sheet) {
      const nameArray = sheet?.data?.['%name'] || null;
      const name = nameArray ? nameArray.find(it => it.lang === 'fr') : null;
      return name ? name._value || '' : '';
    },
    getBordereau(sheet) {
      return bordereauxInternes[sheet.bordereau_interne] || null;
    },
  },
};
</script>

<style lang="scss">
  .sheet-tile {
    color: #1A1A1A;
    font-size: 16px;
    grid-template-columns: 8em 6em 8em 180px 1.5fr;
    .address {
      color: #BCBCBC;
      font-size: 16px;
      .detail {
        font-size: 16px;
        font-style: italic;
      }
    }
  }
</style>